import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteVendorsFromAPI, fetchVendorsFromAPI, fetchAllVendorsFromAPI, fetchDistinctVendorsFromAPI, uploadVendorFileToAPI } from "../../../services/VendorService";



export const fetchAllVendors = createAsyncThunk(
  "vendors/fetchAllVendors",
  async ({  }, { rejectWithValue }) => {
    try {
      const response = await fetchAllVendorsFromAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);

export const fetchDistinctVendors = createAsyncThunk(
  "vendors/fetchDistinctVendors",
  async ({  }, { rejectWithValue }) => {
    try {
      const response = await fetchDistinctVendorsFromAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data vendor distinct");
    }
  }
);

export const fetchVendors = createAsyncThunk(
  "vendors/fetchVendors",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchVendorsFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteVendor = createAsyncThunk(
  "vendors/deleteVendor",
  async (vendorId, { rejectWithValue }) => {
    try {
      const response = await deleteVendorsFromAPI(vendorId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);

// Upload Vendor File
export const uploadVendorFile = createAsyncThunk(
  "vendors/uploadVendorFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadVendorFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const vendorSlice = createSlice({
  name: "vendors",
  initialState: {
    vendors: [],
    AllVendors:[],
    DistinctVendors:[],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    vendorSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    withEmail: 0,
    destinations: 0,
    keywordSearch:"",
    columnFilters: {}
  },
  reducers: {
    setSearchVendor: (state, action) => {
      state.vendorSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetVendorState: (state) => {
      state.vendors = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        const vendors = action.payload.vendors;
        state.loading = false;
        state.vendors = vendors.data;
        state.currentPage = vendors.current_page;
        state.lastPage = vendors.last_page;
        state.perPage = vendors.per_page;
        state.firstItem = vendors.from; // ✅ Ambil `from` dari API
        state.totalCount = vendors.total;
        state.withEmail = vendors.with_email ?? 0;
        state.destinations = vendors.destinations ?? 0;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllVendors.fulfilled, (state, action) => {
        const vendors = action.payload.vendors;
        state.AllVendors = vendors.data;
      })
      .addCase(fetchDistinctVendors.fulfilled, (state, action) => {
        const vendors = action.payload.vendors;
        state.DistinctVendors = vendors.data;
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.vendors = state.vendors.filter(vendor => vendor.id !== action.payload);
      })
      .addCase(deleteVendor.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadVendorFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadVendorFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the vendor list after successful upload
        // You can dispatch fetchVendors here if needed
      })
      .addCase(uploadVendorFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchVendor, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetVendorState } = vendorSlice.actions;
export default vendorSlice.reducer;
